import React from 'react';
import { connect } from 'react-redux';

import { createComponent, Layout, Header, Button, Label, enums, PropTypes } from 'console-kit';
import authStatics from '../../../common/static';

import MultipleSessionSsoActions from '../redux/actions';
import AuthImageLogo from '../../../components/AuthImageLogo';

const MultipleSessionSsoPanel = createComponent({
  displayName: 'MultipleSessionSsoPanel',
  propTypes:   {
    continueUrl: PropTypes.string,
    switchUrl:   PropTypes.string,
    newUser:     PropTypes.string,
    current:     PropTypes.string,
  },
  defaultProps: {
    continueUrl: undefined,
    switchUrl:   undefined,
    newUser:     undefined,
    current:     undefined,
  },
  handlers: {
    handleClickUseCurrent: p => (e, { value }) => {
      p.onLoginCurrentRequestClicked();
      window.location.href = value;
    },

    handleClickUseNewUser: p => (e, { value }) => {
      p.onLoginNewUserRequestClicked();
      window.location.href = value;
    },
  },
  render(props) {
    return (
      <div className={authStatics.SCREEN_CLASSES}>
        <Layout isFluidHeight>
          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.CENTER}>
              <AuthImageLogo />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.LEFT}>
              <Header
                text="Choose an account"
                isDividing={false}
                font={{
                  emphasis: enums.font.emphasis.NORMAL,
                }}
                size={enums.sizes.X6}
              />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.LEFT}>
              <Label
                text="You already have an active session with a different user. Do you want to keep your session or initiate a new one?."
                hasPadding={false}
                display={enums.display.PLAIN}
                size={enums.sizes.X4}
                isFluid
              />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Button.WithAnimation
              actions={{
                start:   MultipleSessionSsoActions.onLoginCurrentRequest,
                success: MultipleSessionSsoActions.onLoginCurrentSuccess, //no action
                failure: MultipleSessionSsoActions.onLoginCurrentFailure, //no action
              }}
            >
              <Button.Primary
                text={`Continue with ${props.current}`}
                float={enums.positions.RIGHT}
                size={enums.sizes.X4}
                value={props.continueUrl}
                onClick={props.handleClickUseCurrent}
                textAlign={enums.textAlignments.CENTER}
                color={enums.colors.ACCENT}
                isSolid
                isFluid
                isDisabled={false}
              />
            </Button.WithAnimation>
          </Layout.Row>

          <Layout.Row>
            <Button.WithAnimation
              actions={{
                start:   MultipleSessionSsoActions.onLoginNewUserRequest,
                success: MultipleSessionSsoActions.onLoginNewUserSuccess, //no action
                failure: MultipleSessionSsoActions.onLoginNewUserFailure, //no action
              }}
            >
              <Button.Primary
                text={`Initiate a new session with ${props.newUser}`}
                float={enums.positions.RIGHT}
                size={enums.sizes.X4}
                value={props.switchUrl}
                onClick={props.handleClickUseNewUser}
                textAlign={enums.textAlignments.CENTER}
                color={enums.colors.ACCENT}
                isSolid
                isFluid
                isDisabled={false}
              />
            </Button.WithAnimation>
          </Layout.Row>
        </Layout>
      </div>
    );
  },
});

export default connect(null, dispatch => ({
  onLoginCurrentRequestClicked() {
    dispatch(MultipleSessionSsoActions.onLoginCurrentRequest());
  },

  onLoginNewUserRequestClicked() {
    dispatch(MultipleSessionSsoActions.onLoginNewUserRequest());
  },
}))(MultipleSessionSsoPanel);
